import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Edit1 } from 'blaze-ui/icons'

interface ReplaceButtonProps extends Pick<ButtonProps, 'isDisabled'> {
  onReplace: (file: File) => void
}

export const ReplaceButton = ({ onReplace, isDisabled }: ReplaceButtonProps) => (
  <FileTrigger
    accept={['image/*']}
    allowsMultiple={false}
    onSelect={async (files) => {
      if (files && files.length > 0) {
        onReplace(files[0])
      }
    }}
  >
    <IconButton size="sm" variant="secondary" icon={Edit1} isDisabled={isDisabled} aria-label="Replace logo" />
  </FileTrigger>
)
